export class LicenseData {
    tenasysentitlementid = "";
    license = "";
    licenseUrl = "";
}